






























import { defineComponent, getCurrentInstance, ref } from '@vue/composition-api';
import { ArrowLeftIcon, ChevronRightIcon } from 'tdesign-icons-vue';
import ApplyDetailDialog from '@/renderer/components/dialog/FileApply/components/ApplyDetailDialog.vue';
import { ApplyTableType } from '@/renderer/views/desktop/FileManagement/FileApply/composition/listHandler';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import FileApplyTable from './components/FileApplyTable.vue';
export default defineComponent({
  name: 'FileApply',
  components: {
    ArrowLeftIcon,
    ChevronRightIcon,
    ApplyDetailDialog,
    FileApplyTable,
  },
  setup(_, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const router = vm.$router;
    const tabValue = ref(router.currentRoute.query.tab);
    const methods = {
      tabChange(val: string) {
        dispatchRouter(
          {
            name: 'fileApply',
            query: {
              tab: val,
            },
          },
          'replace',
        );
      },
      backToRelateToMe() {
        dispatchRouter({
          name: 'relatedToMe',
        });
      },
    };
    return {
      tabValue,
      ApplyTableType,
      ...methods,
    };
  },
});
